import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { Constant5dc3leeorpdb as Constant } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant_0,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { plus18eogev54fmsa as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  beginUse146s8dwmfk72s as beginUse,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_atTopEnd21ub47e8cwtv6 as get_atTopEnd } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { closePopovers89geeulkriez as closePopovers } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.mjs';
import { get_textButtonybbt8y3eu5hx as get_textButton } from './buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { body3i5t0n7zprpqb as body } from './Titles.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ToDoSemanticClass;
function ToDoSemantic() {
  if (ToDoSemanticClass === VOID) {
    class $ extends Semantic() {
      static yjp(color) {
        var $this = this.bd1('todo' + color.ecz());
        $this.xjp_1 = color;
        return $this;
      }
      cd1(theme) {
        var tmp0_outlineWidth = get_dp(2);
        var tmp1_cornerRadii = new (Constant())(get_AppDimensions().pg2_1);
        var tmp2_outline = this.xjp_1;
        var tmp3_padding = Edges().ad0(get_AppDimensions().xg1_1);
        return this.hd1(theme, false, VOID, VOID, tmp1_cornerRadii, VOID, tmp3_padding, VOID, VOID, tmp2_outline, tmp0_outlineWidth);
      }
      toString() {
        return 'ToDoSemantic(color=' + this.xjp_1.toString() + ')';
      }
      hashCode() {
        return this.xjp_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ToDoSemantic()))
          return false;
        if (!this.xjp_1.equals(other.xjp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ToDoSemantic');
    ToDoSemanticClass = $;
  }
  return ToDoSemanticClass;
}
function toDoSection(_this__u8e3s4, color) {
  return _this__u8e3s4.hbb(ToDoSemantic().yjp(color));
}
var NotificationBarSemanticClass;
function NotificationBarSemantic() {
  if (NotificationBarSemanticClass === VOID) {
    class $ extends Semantic() {
      static lg0(colors) {
        var $this = this.bd1('not' + colors.xg9_1.ecz());
        $this.kg0_1 = colors;
        return $this;
      }
      cd1(theme) {
        var tmp0_background = this.kg0_1.aga_1;
        var tmp1_outline = this.kg0_1.yg9_1;
        var tmp2_outlineWidth = get_AppDimensions().og2_1;
        var tmp3_cornerRadii = new (Constant())(get_AppDimensions().pg2_1);
        var tmp4_gap = get_rem(1);
        var tmp5_padding = Edges().ad0(get_rem(1));
        return this.hd1(theme, VOID, VOID, VOID, tmp3_cornerRadii, tmp4_gap, tmp5_padding, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
      }
      toString() {
        return 'NotificationBarSemantic(colors=' + this.kg0_1.toString() + ')';
      }
      hashCode() {
        return this.kg0_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotificationBarSemantic()))
          return false;
        if (!this.kg0_1.equals(other.kg0_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NotificationBarSemantic');
    NotificationBarSemanticClass = $;
  }
  return NotificationBarSemanticClass;
}
function notificationBar(_this__u8e3s4, colors) {
  return _this__u8e3s4.hbb(NotificationBarSemantic().lg0(colors));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp0 = 'hidden-banners';
        // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
        var defaultValue = emptySet();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_0 = serializer(createKType(getKClass(KtSet()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false))]), false));
        var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
        tmp.zjp_1 = PersistentProperty().od8(tmp0, defaultValue, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Signal$_get_value_$ref_i3pjsd(p0) {
  return () => p0.f2();
}
function Signal$_set_value_$ref_nmk1s7(p0) {
  return (_this__u8e3s4) => {
    p0.mam(_this__u8e3s4);
    return Unit_instance;
  };
}
function DismissibleHandler$_get_value_$ref_exd1vd() {
  return (p0) => p0.f2();
}
function DismissibleHandler$_set_value_$ref_edhej7() {
  return (p0, p1) => {
    p0.ham(p1);
    return Unit_instance;
  };
}
function DismissibleHandler$_get_value_$ref_exd1vd_0() {
  return (p0) => p0.f2();
}
function DismissibleHandler$_set_value_$ref_edhej7_0() {
  return (p0, p1) => {
    p0.ham(p1);
    return Unit_instance;
  };
}
var DismissibleHandlerClass;
function DismissibleHandler() {
  if (DismissibleHandlerClass === VOID) {
    class $ {
      constructor(name) {
        Companion_getInstance_0();
        this.ajq_1 = name;
        this.bjq_1 = Signal().fak(!Companion_getInstance_0().zjp_1.f2().t1(this.ajq_1));
        var tmp = this;
        var tmp0 = this.bjq_1;
        var tmp_0 = KMutableProperty0();
        var tmp_1 = Signal$_get_value_$ref_i3pjsd(tmp0);
        tmp.cjq_1 = getPropertyCallableRef('value', 0, tmp_0, tmp_1, Signal$_set_value_$ref_nmk1s7(tmp0));
      }
      djq() {
        this.bjq_1.mam(false);
        var _receiver__tnumb7 = Companion_getInstance_0().zjp_1;
        _receiver__tnumb7.mam(plus(_receiver__tnumb7.f2(), this.ajq_1));
      }
      ham(_set____db54di) {
        var tmp0 = this.cjq_1;
        var tmp = KMutableProperty1();
        var tmp_0 = DismissibleHandler$_get_value_$ref_exd1vd_0();
        // Inline function 'kotlin.setValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, DismissibleHandler$_set_value_$ref_edhej7_0());
        tmp0.set(_set____db54di);
        return Unit_instance;
      }
      mam(_set____db54di) {
        return this.ham((!(_set____db54di == null) ? typeof _set____db54di === 'boolean' : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        var tmp0 = this.cjq_1;
        var tmp = KMutableProperty1();
        var tmp_0 = DismissibleHandler$_get_value_$ref_exd1vd();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('value', 1, tmp, tmp_0, DismissibleHandler$_set_value_$ref_edhej7());
        return tmp0.get();
      }
      tah(listener) {
        return this.bjq_1.tah(listener);
      }
      oam(thisRef, property) {
        return this.nam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      qam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.pam(tmp, property, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
    }
    protoOf($).cak = valueSet;
    protoOf($).gah = set;
    protoOf($).nam = getValue;
    protoOf($).pam = setValue;
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    protoOf($).qah = get_state;
    protoOf($).iaj = beginUse;
    initMetadataForClass($, 'DismissibleHandler', VOID, VOID, [MutableReactiveValue()], [1]);
    DismissibleHandlerClass = $;
  }
  return DismissibleHandlerClass;
}
function dismissible(_this__u8e3s4, handler, setup) {
  var tmp = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.baj($this$shownWhen.baj(handler)));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  setup(view);
  var tmp_0 = get_atTopEnd(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (MenuButton())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var $this$menuButton = view_0;
  $this$menuButton.eba(get_dp(3));
  $this$menuButton.yc3_1 = true;
  icon($this$menuButton, resize(Companion_getInstance().tcf_1, get_rem(1)), 'Dismiss Banner');
  var close = () => {
    closePopovers($this$menuButton);
    return Unit_instance;
  };
  $this$menuButton.ec4(($this$opensMenu) => {
    $this$opensMenu.eba(get_rem(1));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.ebb(p, view);
    view.xbm(true);
    view.zb8(get_px(0));
    var tmp = get_textButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    body(view_0, 'Dismiss Once');
    onClick(view_0, VOID, VOID, dismissible$lambda$slambda_0(handler, close));
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_0 = get_textButton(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    body(view_1, 'Dismiss Forever');
    onClick(view_1, VOID, VOID, dismissible$lambda$slambda_2(handler, close));
    view.fbb(p_1, view_1);
    view.jbb(tmp_0, view_1);
    $this$opensMenu.fbb(p, view);
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function dismissableBanner(_this__u8e3s4, name, setup) {
  return dismissible(_this__u8e3s4, new (Constant_0())(_Constant___init__impl__v45mub(new (DismissibleHandler())(name))), setup);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ejq_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.ham(false);
  $this.fjq_1();
  return Unit_instance;
}
var dismissible$lambda$slambdaClass;
function dismissible$lambda$slambda() {
  if (dismissible$lambda$slambdaClass === VOID) {
    class $ {
      constructor($handler, $close) {
        this.ejq_1 = $handler;
        this.fjq_1 = $close;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    dismissible$lambda$slambdaClass = $;
  }
  return dismissible$lambda$slambdaClass;
}
function dismissible$lambda$slambda_0($handler, $close) {
  var i = new (dismissible$lambda$slambda())($handler, $close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.gjq_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.djq();
  $this.hjq_1();
  return Unit_instance;
}
var dismissible$lambda$slambdaClass_0;
function dismissible$lambda$slambda_1() {
  if (dismissible$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($handler, $close) {
        this.gjq_1 = $handler;
        this.hjq_1 = $close;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    dismissible$lambda$slambdaClass_0 = $;
  }
  return dismissible$lambda$slambdaClass_0;
}
function dismissible$lambda$slambda_2($handler, $close) {
  var i = new (dismissible$lambda$slambda_1())($handler, $close);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  DismissibleHandler as DismissibleHandler1ifn4mn1pfh06,
  NotificationBarSemantic as NotificationBarSemanticwa6jjp0en36y,
  dismissableBanner as dismissableBanner3s49vuosvr23r,
  dismissible as dismissible3oiauji9y5bdb,
  notificationBar as notificationBar4efejtg2792g,
  toDoSection as toDoSection277aoqfqgiijq,
};
//endregion

//# sourceMappingURL=banners.mjs.map
